import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import DateRangeSelector, {
  DateRangeType,
} from "../../../ui/DateRangeSelector";
import { fetchTransactionAnalyticsAsync } from "../../../../redux/features/analyticsSlice";
import moment from "moment";
import CustomTable from "../../../../components/Tables/CustomTable";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import FilterByButton from "../../../ui/FilterButton";
import { useNavigate } from "react-router-dom";
import {
  transactionColumns,
  transactionRows,
  transactionStatusOptions,
} from "../../Analytics/tableUtils";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/app/store";

const ViewRefferdUserTransactions = () => {
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: new Date(moment().startOf("year").toISOString()),
    endDate: new Date(moment().endOf("year").toISOString()),
  });
  const { selectedUser } = useSelector((state: RootState) => state.admin);
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [status, setStatus] = useState<string>("");
  const { loading, transactions } = useAppSelector((state) => state.analytics);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

  useEffect(() => {
    dispatch(
      fetchTransactionAnalyticsAsync({
        page: page + 1,
        limit,
        startDate: selectedRange.startDate,
        endDate: selectedRange.endDate,
        status,
        filter: selectedUser?.email,
      })
    );
  }, [page, limit, selectedRange, dispatch, status, selectedUser?.email]);

  const trasactionMorevertOptions = [
    {
      label: "View transaction details",
      onClick: (id: string) =>
        navigate(`/transactions/transaction-details/${id}`),
      returnBy: "id",
    },
  ];

  const data = {
    columns: transactionColumns,
    rows: transactionRows(transactions?.data, trasactionMorevertOptions),
  };

  return (
    <div className="p-6 flex flex-col gap-6">
      <button
        className="text-gray-500 hover:text-gray-800 flex items-center font-bold max-w-24 space-x-2 mb-4 bg-gray-50 p-2 rounded"
        onClick={() => navigate(-1)}
      >
        &larr; Back
      </button>
      <p className="text-2xl font-bold capitalize">Transactions</p>
      <WhiteTitledCard>
        <div className="p-4">
          <div className="flex flex-col md:justify-between gap-4 mb-4">
            {/* Tabs List */}
            {/* Search and Filter */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 w-full md:w-auto">
              <div className="flex gap-2">
                <DateRangeSelector
                  initialRange={selectedRange}
                  onChange={handleDateChange}
                />
              </div>
              <div className="flex gap-2">
                <FilterByButton
                  options={transactionStatusOptions}
                  onSelect={(value) => {
                    setStatus(value);
                    setPage(0);
                  }}
                  buttonLabel="Transaction Status"
                  defaultValue={status}
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row flex-wrap items-center gap-3"></div>
          </div>

          <CustomTable
            data={data}
            noRecordText="Record is Empty"
            loading={loading}
            showFooter={true}
            totalPages={transactions?.data?.meta?.totalPages}
            itemsPerPage={transactions?.data?.meta?.itemCount}
            currentPage={page}
            onPageChange={(value: number) => setPage(value)}
            onLimitChange={(value: number) => {
              setLimit(value);
              setPage(0);
            }}
          />
        </div>
      </WhiteTitledCard>
    </div>
  );
};

export default ViewRefferdUserTransactions;
